'use strict';

angular.module('app')
    .service('Auth', function ($location, $rootScope, $injector, Request, gettextCatalog, diviacLocalStorage, Wishlist, GTM, localStorageService, DiveOperator, DiveSite, affiliatesService, utils, $timeout) {
        var Auth = {};

        Auth.isLoggedIn = function () {
            return localStorage.getItem('token');
        };

        Auth.tokenVerify = function () {

        };

        Auth.isStaff = function () {
          var user = diviacLocalStorage.get('user');

          return user ? user.isStaff : false;
        };

        Auth.isAffiliate = function () {
          var user = diviacLocalStorage.get('user');

          return user && user.affiliate ? true : false;
        };

        Auth.getReferralCode = function () {
            return $location.search().coupon_code || null;
        };

        Auth.getPromoCoupon = function () {
            return diviacLocalStorage.get('promo_code') || null;
        };

        Auth.registration = function (credentials, promo, disabledRedirect) {

            var _this = this;


            credentials.coupon_code = _this.getReferralCode();
            credentials.code = _this.getPromoCoupon();

            return Request.post('account/register/', credentials).then(function (res) {
                $rootScope.toState = utils.createURL('register_completed')
                if (promo) {
                    _this.promoHandler(res.data);
                } else {
                    _this.handler(res.data, null, disabledRedirect);
                }

                GTM.event('user_registration_complete');

                return $rootScope.showNotify(gettextCatalog.getString('Your account was successfully created.'));
            }, function (error) {

                GTM.event('user_registration_email_error');

                throw _this.handleError(error);
            });
        };

        Auth.login = function (credentials, disabledRedirect) {
            var _this = this;

            credentials.coupon = _this.getPromoCoupon();

            return Request.post('account/login/', credentials).then(function (res) {
                _this.handler(res.data, undefined, disabledRedirect);

                GTM.event('user_login_complete');
                if (res.data.status !== 'terms_not_accepted'){
                    $rootScope.showNotify(gettextCatalog.getString('You are successfully logged in'));
                }
            }, function (error) {
                throw _this.handleError(error);
            });
        }

        Auth.confirmTerms = function (data, disabledRedirect) {
            var _this = this;
            return Request.put('account/terms-and-subscription/', data).then(function(res) {
                res.data.token = _this.getToken();
                _this.handler(res.data, undefined, disabledRedirect);
            })
            
        }

        Auth.socialLogin = function (callback, promo, disabledRedirect) {
            var _this = this;
            FB.login(function (response) {
                if (response.authResponse) {
                    var accessToken = {
                        access_token: response.authResponse.accessToken,
                        coupon_code: _this.getReferralCode(),
                        coupon: _this.getPromoCoupon()
                    };

                    Request.post('account/social/facebook/', accessToken).then(function (res) {
                        if (res.data.token) {
                            GTM.event('user_login_complete');
                            if (promo) {
                                _this.promoHandler(res.data);
                                $rootScope.showNotify(gettextCatalog.getString('Your account was successfully created.'));
                            } else {
                                _this.handler(res.data, callback, disabledRedirect);
                                $rootScope.showNotify(gettextCatalog.getString('You are successfully logged in'));
                            }
                        }
                    });
                } else {
                    GTM.event('user_login_facebook_error');
                }
            }, {scope: 'email'});
        };

        Auth.recoverPassword = function (email) {
            var _this = this;
            return Request.post('account/password/reset/', {email: email}).then(function (data) {
                $rootScope.showNotify(gettextCatalog.getString('Password reset e-mail has been sent'));

                return data;
            }, function (error) {
                throw _this.handleError(error);
            });
        };

        Auth.resetPassword = function (data) {
            var _this = this;

            return Request.post('account/password/reset/confirm/', data).then(function (res) {
                $rootScope.showNotify(gettextCatalog.getString('Your password successfully changed'));
                $location.path(utils.createURL('login'));

                return res;
            }, function (error) {
                throw _this.handleError(error);
            });
        };

        Auth.verifyToken = function () {

        };

        Auth.getToken = function () {
            return localStorage.getItem('token');
        };

        Auth.handleError = function (error) {
            if (error.status === 403) {
                return [error.statusText];
            }

            if (error.data) {
                var messages = [];
                _.each(error.data, function (val) {
                    messages.push(val[0]);
                });

                return messages;
            }
        };

        Auth.handler = function (data, callback, disabledRedirect) {
            var _this = this;

            if (data.token) {
                _this.saveToken(data.token);

                if (data.status === 'terms_not_accepted' && !disabledRedirect) {
                    $location.path(utils.createURL('register_activate'))
                    return true;
                }

                _this.saveUser(data.user);

                diviacLocalStorage.set('userSettings', '');
                diviacLocalStorage.remove('coupon');

                // Account.getPreferences();
                localStorageService.set('paymentInfo', false);

                if (data.user && data.user.affiliate) {
                    // $location.search({
                    //     utm_campaign: 'ww-all-all-affiliates-shops',
                    //     utm_source: 'affiliate_' + data.user.affiliate.memberNumber,
                    //     utm_medium: 'affiliate-user',
                    //     utm_content: 'direct'
                    // })

                    GTM.variables({
                        affiliate_id: data.user.affiliate.memberNumber,
                        affiliate_type: 'Shop affiliate',
                        user_type: 'Affiliate'
                    })
                }

                if (callback) {
                    if ($location.path() === utils.createURL('login') && !disabledRedirect) {
                        _this.redirectBack();
                    }

                    return callback(data);
                }
                var storageReview = localStorageService.get('review');

                if (storageReview) {
                    $rootScope.review = storageReview;
                    localStorageService.remove('review');
                }

                if ($rootScope.review) {
                    if ($rootScope.review.shopSlug) {
                        DiveOperator.addReview($rootScope.review, true).then(function () {
                            _this.redirectBack();
                        });
                    } else if ($rootScope.review.diveSiteSlug) {
                        DiveSite.addReview($rootScope.review, true).then(function () {
                            _this.redirectBack();
                        });
                    } else {
                        DiveOperator.addReviewWithImg($rootScope.review, true).then(function () {
                            _this.redirectBack();
                        });
                    }
                } else if ($rootScope.question) {
                    DiveOperator.askQuestion($rootScope.question).then(function (data) {
                        _this.redirectBack();
                    });
                } else if ($rootScope.wishlist) {
                    Wishlist.add({item_slug: $rootScope.wishlist, item_type:'Shop'}).then(function() {
                        $location.path(utils.createURL('wishlist')).hash('');
                    }).catch(function () {
                         _this.redirectBack();
                    }).finally(function () {
                        $rootScope.wishlist = null;
                    });
                } else if ($rootScope.affiliateData) {
                    var lang = _.clone($rootScope.affiliateData.language);
                    affiliatesService.createNew($rootScope.affiliateData)
                    .then(function() {
                        $location.path(lang === 'de' ? '/de/affiliates/' : '/affiliates/').search({'success': 'true'}).hash('');

                        $timeout(function(){
                            Auth.logout();
                            FB.logout();
                        }, 5000);
                    })
                    .finally(function() {
                        $rootScope.affiliateData = null;
                    })
                } else {
                    if (disabledRedirect) {return true}
                    _this.redirectBack();
                }
            }
        };

        Auth.redirectBack = function () {
            if ($rootScope.toState) {
                $location.path($rootScope.toState).hash('');
                $rootScope.toState = null;

                return 1;
            }

            $location.path(utils.createURL('bookings')).hash('');
            // if ($rootScope.oldState) {
            //     $window.history.back();
            // } else {
            //     $location.path('/').hash('');
            // }
        };

        Auth.saveToken = function (token) {
            localStorage.setItem('token', token);

            return this;
        };

        Auth.saveUser = function (data) {
            if (!data) {
                return this;
            }

            this.setUserGTM(data);
            
            return localStorage.setItem('user', JSON.stringify(data));
        };

        Auth.setUserGTM = function (data) {
            GTM.variables({
                'user_id': data.id,
                'user_email': data.email,
                'user_email_md5': utils.md5(data.email),
                'user_first_name': data.firstName,
                'user_last_name': data.lastName,
                'user_services': data.services,
                'user_currency': data.travelSettings.currency,
                'user_gender': data.gender === 10 ? 'female' : 'male',
                'user_first_registration_at': data.accountRegistrationDate,
                'user_default_airport_code': data.travelSettings.closestAirport,
                'user_default_measurement': data.travelSettings.distanceMeasurement === 0 ? 'metric' : 'imperial',
                'user_default_temperature': data.travelSettings.temperature === 0 ? 'celsius' : 'fahrenheit',
                'user_hash': data.accountIntercomHash,
                'checkout_last_order_at' : data.checkoutLastOrderAt,
                'user_type': data.userType
            });

            return this;
        };

        Auth.getUser = function () {
            return localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : false;
        };

        Auth.promoHandler = function (data) {
            var _this = this;

            if (data.token) {
                _this.saveToken(data.token).logout();
                FB.logout();
            }
        };

        Auth.logout = function () {
            //logout on all our sites;
            Request.post('account/logout/')

            GTM.event('user_login_logout');
            $rootScope.user = false;
            localStorage.setItem('token', '');
            return localStorage.setItem('user', false);
        };

        Auth.activateAccount = function (key) {
            return Request.post('account/confirm/', {activation_key: key});
        };

        Auth.checkCookie = function () {
            var _this = this;
            return Request.get('account/get-token/').then(function (res) {
                if (res.data.token) {
                    _this.saveToken(res.data.token).saveUser(res.data.user);

                    $rootScope.user = _this.getUser();
                }
            });
        };

        Auth.userMeasurements = function () {
            return Request.get('user-measurements/').then(function (res) {
                $rootScope.temperature = res.data.temperature;
                $rootScope.distance = res.data.length;
                $rootScope.currency = utils.getCookie('currency_code') || res.data.currency;
            });
        };

        Auth.checkAffiliate = function() {
            return Request.get('account/affiliate-info/').then(function(res) {
                return res.data
            });
        }

        Auth.showTermsModal = function(callback) {
            var $uibModal = $injector.get('$uibModal')

            var modalInstance = $uibModal.open({
				animation: true,
                backdrop: 'static',
                keyboard: false,
				templateUrl: '../templates/_activate_account-popup.html',
				controller: function($rootScope, $uibModalInstance) {
                    var vm = this;

                    vm.form = {
                        isTermsAccepted: false,
                        toSubscribe: false
                    }

                    vm.activate = function(form) {
                        if (form.$invalid) {return false}

                        Auth.confirmTerms(vm.form, true).then(function() {
                            $rootScope.user = Auth.getUser();
                            $uibModalInstance.close()
                        })
                    }
                },
                controllerAs: 'termsPopup'
            })

			return modalInstance.result.then(function(res) {
                if (callback) { callback() }
			}, function(err) {
			})
        }

        return Auth;


    });
